import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { getMailThreads, getMailPaging, getTimeLastRefresh } from 'selectors';
import { MailThreadShape } from 'entities';
import './style.scss';

let ChatInfo;
ChatInfo = require('./ChatInfo').default;

let RepliesList, RepliesListLoading, RepliesListContentMain, RepliesListContentSticky, MailThreadsListHeader, MailThreadsListPageSelector, MailThread;
RepliesList = require('components/RepliesList').default;
RepliesListLoading = require('components/RepliesListLoading').default;
RepliesListContentMain = require('components/RepliesList/RepliesListContentMain').default;
RepliesListContentSticky = require('components/RepliesList/RepliesListContentSticky').default;
MailThreadsListHeader = require('./MailThreadsListHeader').default;
MailThreadsListPageSelector = require('./MailThreadsListPageSelector').default;
MailThread = require('./MailThread').default;

export class MailThreadsList extends Component {

  render() {
    const isMailEnabled = RepliesList !== undefined;
    return (
      <div className="FlexRow">
        {ChatInfo && <ChatInfo isCentered={!isMailEnabled} />}

        {RepliesList && (
        <RepliesList>
          <RepliesListContentMain>
            <MailThreadsListHeader />

            {(() => {
              if(this.props.mailThreads.length > 0) {
                return (
                  <ul>
                    {this.props.mailThreads.map(mailThread => <MailThread key={mailThread.id} mailThread={mailThread} />)}
                  </ul>
                );
              }
              else if(this.props.isFetching) {
                return (
                  <RepliesListLoading />
                );
              }
            })()}
          </RepliesListContentMain>

          {(() => {
            if(this.props.pagesCount > 1) {
              return (
                <RepliesListContentSticky>
                  <MailThreadsListPageSelector />
                </RepliesListContentSticky>
              );
            }
          })()}
        </RepliesList>
        )}
      </div>
    );
  }
}

MailThreadsList.propTypes = {
  mailThreads: PropTypes.arrayOf(MailThreadShape),
  isFetching: PropTypes.bool,
  pagesCount: PropTypes.number,
  onFetchCurrentPage: PropTypes.func,
  lastRefresh: PropTypes.object
};

function mapStateToProps(state) {
  const { page, isFetching, pagesCount } = getMailPaging(state, 'mailThreads');

	return {
    mailThreads: getMailThreads(state, { page }),
    lastRefresh: getTimeLastRefresh(state),
    isFetching,
    pagesCount
  };
}

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailThreadsList);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadsList/index.js
 **/